type NullsToUndefined<T> = {
  [K in keyof T]: null extends T[K] ? Exclude<T[K], null> | undefined : T[K];
};

export function nullsToUndefined<T extends object>(obj: T): NullsToUndefined<T> {
  return Object.keys(obj).reduce(
    (acc, key) => {
      acc[key] = (obj as Record<string, unknown>)[key] ?? undefined;
      return acc;
    },
    {} as Record<string, unknown>,
  ) as NullsToUndefined<T>;
}
